var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class BantaServiceChatSource {
    constructor(identifier, underlyingChatSource, backend, collectionPath) {
        this.identifier = identifier;
        this.underlyingChatSource = underlyingChatSource;
        this.backend = backend;
        this.collectionPath = collectionPath;
    }
    get messageReceived() {
        return this.underlyingChatSource.messageReceived;
    }
    get messageSent() {
        return this.underlyingChatSource.messageSent;
    }
    get messages() {
        return this.underlyingChatSource.messages;
    }
    send(message) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.backend.userToken) {
                // Not signed in
                console.error(`Cannot send message: Not signed in.`);
                return;
            }
            let response = yield fetch(`${this.backend.baseUrl}${this.collectionPath}`, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.backend.userToken}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(message)
            });
            if (response.status >= 400) {
                let body = yield response.json();
                throw new Error(`Caught error sending message: ${response.status} ${response.statusText}: ${body.message || '<no message>'}`);
            }
            //messageSent.next(message);
            return yield response.json();
        });
    }
    close() {
        if (this.underlyingChatSource.close)
            this.underlyingChatSource.close();
    }
}
export class BantaServiceChatBackend {
    constructor(_underlyingChatBackend, baseUrl) {
        this._underlyingChatBackend = _underlyingChatBackend;
        this.baseUrl = baseUrl;
    }
    get underlyingChatBackend() {
        return this._underlyingChatBackend;
    }
    get notificationsChanged() {
        return this._underlyingChatBackend.notificationsChanged;
    }
    get newNotification() {
        return this._underlyingChatBackend.newNotification;
    }
    getSourceForTopic(topicId) {
        return __awaiter(this, void 0, void 0, function* () {
            return new BantaServiceChatSource(topicId, yield this._underlyingChatBackend.getSourceForTopic(topicId), this, `/topics/${topicId}/messages`);
        });
    }
    getSourceForThread(topicId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return new BantaServiceChatSource(topicId, yield this._underlyingChatBackend.getSourceForThread(topicId, messageId), this, `/topics/${topicId}/messages/${messageId}/messages`);
        });
    }
    refreshMessage(message) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._underlyingChatBackend.refreshMessage(message);
        });
    }
    getMessage(topicId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._underlyingChatBackend.getMessage(topicId, messageId);
        });
    }
    getSubMessage(topicId, parentMessageId, messageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this._underlyingChatBackend.getSubMessage(topicId, parentMessageId, messageId);
        });
    }
    watchMessage(message, handler) {
        return this._underlyingChatBackend.watchMessage(message, handler);
    }
    upvoteMessage(topicId, messageId, submessageId) {
        return __awaiter(this, void 0, void 0, function* () {
            let path = `${this.baseUrl}/topics/${topicId}/messages/${messageId}/upvote`;
            if (submessageId)
                path = `${this.baseUrl}/topics/${topicId}/messages/${messageId}/messages/${submessageId}/upvote`;
            let response = yield fetch(path, {
                method: 'POST',
                headers: {
                    'Authorization': `Bearer ${this.userToken}`,
                    'Content-Type': 'application/json'
                },
                body: '{}'
            });
            if (response.status >= 400) {
                let body = yield response.json();
                throw new Error(`Caught error upvoting message ${topicId}/${messageId}: ${response.status} ${response.statusText}: ${body.message || '<no message>'}`);
            }
        });
    }
}
//# sourceMappingURL=banta-service-chat-backend.js.map